import { Component, OnInit } from "@angular/core";
import { UserService } from "../services/user.service";
import { OfframpService } from "../services/offramp.service";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

import { MatDatepickerInputEvent } from "@angular/material";
import * as moment from "moment";
import { TableUtil } from "../admintrademaster/tableUtil";
import { NotificationsService } from "angular2-notifications";
import { ColDef, GridOptions, GridApi, ColumnApi } from "ag-grid-community";

const defaults = {
  notif: {
    timeOut: 3000,
    showProgressBar: true,
    pauseOnHover: false,
    clickToClose: true,
    maxLength: 50,
  },
};

@Component({
  selector: "app-offramp-daily-log",
  templateUrl: "./offramp-daily-log.component.html",
  styleUrls: ["./offramp-daily-log.component.css"],
})
export class OfframpDailyLogComponent implements OnInit {
  _csrf: string;

  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  gridOptions: GridOptions;
  columnDefs: ColDef[] = [];
  rowData: any[] = [];
  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    minWidth: 100
  };

  oLogs: any = [];
  logs: any = [];
  searchValue: string = '';
  filter: any = {
    page: 1,
    limit: 100,
    KeyPerson: '',
    Source: '',
    fromDate: moment().subtract(30, "d").format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
  };
  prev_disabled = true;
  next_disabled = false;

  myFilter = (d: Date | null): boolean => {
    return true;
  };

  constructor(
    private notifSer: NotificationsService,
    private userService: UserService,
    private offrampService: OfframpService,
    private spinnerService: Ng4LoadingSpinnerService
  ) {
    this.initializeGrid();
  }

  ngOnInit() {
    this.csrf();
  }

  initializeGrid() {
    this.columnDefs = [
      { headerName: 'Date', field: 'Date', flex: 1 },
      { headerName: 'Key Person', field: 'KeyPerson', flex: 1 },
      { headerName: 'Source', field: 'Source', flex: 1 },
      { headerName: 'Slot', field: 'Slot', valueFormatter: (params) => this.formatNumber(params.value, 8), flex: 0.9 },
      { headerName: 'Buy Rate', field: 'BuyRate', valueFormatter: (params) => this.formatNumber(params.value, 2), flex: 0.9 },
      { headerName: 'Buy Total', field: 'BuyTotal', valueFormatter: (params) => this.formatNumber(params.value, 2), flex: 1 },
      { headerName: 'Sell Rate', field: 'SellRate', valueFormatter: (params) => this.formatNumber(params.value, 2), flex: 0.9 },
      { headerName: 'Fee Rate', field: 'FeeRate', valueFormatter: (params) => this.formatNumber(params.value, 3), flex: 0.9 },
      { headerName: 'Sell Total', field: 'SellTotal', valueFormatter: (params) => this.formatNumber(params.value, 2), flex: 1 },
      { headerName: 'Gross P&L', field: 'GrossPnL', valueFormatter: (params) => this.formatNumber(params.value, 2), flex: 1 },
      { headerName: 'Profit Share 15% (Crypto)', field: 'ProfitShare15_Crypto', valueFormatter: (params) => this.formatNumber(params.value, 8), flex: 1.2 },
      { headerName: 'Profit Share 20% (Crypto)', field: 'ProfitShare20_Crypto', valueFormatter: (params) => this.formatNumber(params.value, 8), flex: 1.2 },
      { headerName: 'Profit Share 15% (Fiat)', field: 'ProfitShare15_Fiat', valueFormatter: (params) => this.formatNumber(params.value, 2), flex: 1.1 },
      { headerName: 'Profit Share 20% (Fiat)', field: 'ProfitShare20_Fiat', valueFormatter: (params) => this.formatNumber(params.value, 2), flex: 1.1 },
      { headerName: 'Final Net P&L', field: 'FinalNetPnL', valueFormatter: (params) => this.formatNumber(params.value, 2), flex: 1.1 },
      { headerName: 'Key', field: 'Key', flex: 0.8 },
      { headerName: 'Capital Pool Assigned', field: 'CapitalPoolAssigned', valueFormatter: (params) => this.formatNumber(params.value, 2), flex: 1.2 },
      {
        headerName: 'CreatedAt',
        field: 'createdAt',
        valueFormatter: (params) => params.value ? moment(params.value).format('MMM DD, YYYY hh:mm:ss A') : '',
        flex: 1.5
      }
    ];

    this.gridOptions = {
      enableCellTextSelection: true,
      ensureDomOrder: true,
      columnDefs: this.columnDefs,
      defaultColDef: this.defaultColDef,
      rowData: this.rowData,
      pagination: false,
      suppressHorizontalScroll: false,
      enableRangeSelection: true,
      animateRows: true,
      rowHeight: 40,
      headerHeight: 40
    };
  }

  formatNumber(value: any, decimals: number = 2): string {
    if (value === null || value === undefined || isNaN(value)) return '';
    return Number(value).toLocaleString('en-IN', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

  csrf() {
    this.userService.csrf().subscribe(
      (success) => {
        this._csrf = success._csrf;
        this.getData();
      },
      (error) => {
        this.notifSer.error("Error", error.error.message, defaults.notif);
      }
    );
  }

  goNext(type = 1) {
    if (type == 1) {
      this.filter.page++;
      this.getData();
    }
  }

  goPrev(type = 1) {
    if (type == 1) {
      if (this.filter.page > 1) {
        this.filter.page--;
        this.getData();
      }
    }
  }

  fromDateFilter(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.filter["fromDate"] = moment(event.value).format("YYYY-MM-DD");
    }
  }

  toDateFilter(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.filter["toDate"] = moment(event.value).format("YYYY-MM-DD");
    }
  }

  // Client-side quick search only (does NOT call the API)
  applyFilter(filterValue) {
    this.searchValue = filterValue || '';

    if (this.gridApi) {
      this.gridApi.setQuickFilter(this.searchValue);
    }

    this.applyFilterToLocalData(this.searchValue);
  }

  clearSearch() {
    this.searchValue = '';
    this.applyFilter('');
  }

  applyFilterToLocalData(searchValue: string) {
    if (searchValue) {
      const search = searchValue.toLowerCase();
      this.logs = this.oLogs.filter((x: any) => {
        return (
          (x.KeyPerson && x.KeyPerson.toLowerCase().includes(search)) ||
          (x.Source && x.Source.toLowerCase().includes(search)) ||
          (x.Key && x.Key.toLowerCase().includes(search))
        );
      });
    } else {
      this.logs = this.oLogs;
    }
  }

  getData() {
    this.spinnerService.show();
    this.filter._csrf = this._csrf;
    this.offrampService.getAllOfframpDailyLog(this.filter).subscribe((response: any) => {
      const list = (response && response.data) || [];
      this.logs = list;
      this.oLogs = list;
      this.rowData = list;

      if (this.gridApi) {
        this.gridApi.setRowData(this.rowData);
        if (this.searchValue) {
          this.gridApi.setQuickFilter(this.searchValue);
          this.applyFilterToLocalData(this.searchValue);
        } else {
          this.gridApi.setQuickFilter('');
          this.logs = this.oLogs;
        }
      }

      this.spinnerService.hide();
      this.prev_disabled = this.filter.page <= 1;
      this.next_disabled = !list || list.length < this.filter.limit;
    }, (error) => {
      this.spinnerService.hide();
      this.notifSer.error("Error", (error.error && error.error.message) || "Failed to fetch offramp daily log", defaults.notif);
    });
  }

  resetFilters() {
    this.filter = {
      page: 1,
      limit: 100,
      KeyPerson: '',
      Source: '',
      fromDate: moment().subtract(30, "d").format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    };

    this.searchValue = '';
    if (this.gridApi) {
      this.gridApi.setQuickFilter('');
    }

    this.logs = this.oLogs;
    this.getData();
  }

  exportArray() {
    this.spinnerService.show();

    const exportFilter = {
      _csrf: this._csrf,
      fromDate: this.filter.fromDate,
      toDate: this.filter.toDate,
      KeyPerson: this.filter.KeyPerson,
      Source: this.filter.Source,
      page: 1,
      limit: 10000
    };

    this.offrampService.getAllOfframpDailyLog(exportFilter).subscribe(
      (response: any) => {
        const list = (response && response.data) || [];
        if (list.length > 0) {
          const exportData = list.map((x: any) => ({
            'Date': x.Date,
            'Key Person': x.KeyPerson,
            'Source': x.Source,
            'Slot': x.Slot,
            'Buy Rate': x.BuyRate,
            'Buy Total': x.BuyTotal,
            'Sell Rate': x.SellRate,
            'Fee Rate': x.FeeRate,
            'Sell Total': x.SellTotal,
            'Gross P&L': x.GrossPnL,
            'Profit Share 15% (Crypto)': x.ProfitShare15_Crypto,
            'Profit Share 20% (Crypto)': x.ProfitShare20_Crypto,
            'Profit Share 15% (Fiat)': x.ProfitShare15_Fiat,
            'Profit Share 20% (Fiat)': x.ProfitShare20_Fiat,
            'Final Net P&L': x.FinalNetPnL,
            'Key': x.Key,
            'Capital Pool Assigned': x.CapitalPoolAssigned,
          }));
          TableUtil.exportArrayToExcel(exportData, 'OfframpDailyLog');
        } else {
          this.notifSer.info("Info", "No data available to export", defaults.notif);
        }
        this.spinnerService.hide();
      },
      (error) => {
        this.spinnerService.hide();
        this.notifSer.error("Error", "Failed to export data. Please try again.", defaults.notif);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/offramp-daily-log/offramp-daily-log.component.ts